<template>
    <div class="animated fadeIn">
        <spinner v-if="loading"/>
        <b-row>
            <b-col sm="12">
                <b-card>
                    <div slot="header">
                        <strong>Search Stockist</strong>
                    </div>
                    <b-row>
                        <b-col sm="3">
                            <label>Stockist</label>
                                <b-form-input type="text" v-model="filter.stockist_id"></b-form-input>
                        </b-col>
                        <b-col sm="3">
                            <label>Date From</label>
                                <b-form-input type="date" v-model="filter.date_start"></b-form-input>
                        </b-col>
                        <b-col sm ="3">
                            <label>Date To</label>
                                <b-form-input type="date" v-model="filter.date_to"></b-form-input>
                        </b-col>
                        <b-col sm = "3">
                            <label for="status">Status</label>
                            <b-form-group>
                                <b-form-select id="status" v-model="filter.status" :plain="true" :options="['','PENDING', 'PICKING', 'PARTIAL-IN-TRANSIT','IN-TRANSIT','DELIVERED']" value="">
                                </b-form-select>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <div slot="footer">
                        <b-button type="submit" size="lg" variant="primary" @click="search">Search</b-button>
                    </div>
                </b-card>
            </b-col>
        </b-row>
        <b-row v-if ="searchResults.length > 0 && !loading || 1">
            <b-col sm="12">
                <b-card>
                    <div slot ="header">
                        <strong>Search Result</strong>
                    </div>
                    <div class = "table-responsive">
                        <b-table class="table-hover" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :fields="searchResultsFields" :current-page="currentPage" 
                        :per-page="perPage" :items="searchResults">
                        <template slot="check_box" slot-scope = "row">
                            <input type="checkbox" v-model="selectedSalesDoc" :value="row.item.sale_id">
                        </template>
                        </b-table>
                    </div>
                    <nav>
                        <b-pagination :total-rows="getRowCount(searchResults)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
                    </nav>
                    <b-row>
                        <b-button type="submit" size="lg" variant="primary" @click="previewPickingList" v-if="selectedSalesDoc.length > 0">Generate Pick List</b-button>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import axios from 'axios'
import spinner from '@/components/Spinner.vue'
import countryLookup from '@/components/Autocomplete.vue'
import {authHeader, apiCountryLookup, apiWsiSearch, apipreviewPickingList} from '@/functions/common.vue'

export default
{
    components:{spinner},
    props: {
      caption: 
      {
        type: String,
        default: 'Table'
      },
      hover: 
      {
        type: Boolean,
        default: false
      },
      striped: 
      {
        type: Boolean,
        default: false
      },
      bordered: 
      {
        type: Boolean,
        default: false
      },
      small: 
      {
        type: Boolean,
        default: false
      },
      fixed: 
      {
        type: Boolean,
        default: false
      }
    },
    created()
    {
        
    },
    data()
    {
        return{
            loading : false,
            modalShow: false,
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            noResults: false,
            selectedSalesDoc:[],
            filter:{
                stockist_id:'',
                date_start:'',
                date_end:'',
                status:'',
            },
            searchResults:[],
            searchResultsFields:[
                {key: 'trans_date', label: 'Transaction Date'},
                {key: 'sales_doc_num', label: 'Sales Doc No.'},
                {key: 'customer_id', label: 'IBO ID'},
                {key: 'customer_name', label: 'IBO Name'},
                {key: 'status',label:'Status'},
                {key: 'check_box',label :' ','class': 'text-center'},
            ],
            picklistInfo:[],
            picklistInfoFields:
            [
                {key: 'picking_list_date', label: 'Pick Date'},
                {key: 'picking_list_num' ,label: 'Pick List No'},
                {key: 'author_user_shortname' ,label: 'Created By'},
                {key: 'do_date' ,label: 'Do Date'},
                {key: 'do_num' ,label: 'Do Num'},
                {key: 'do_author_user_shortname' ,label: 'Created By'},
                {key: 'courier_num' ,label: 'Courier No'},
                {key: 'courier_company' ,label: 'Courier Company'},
            ]
        }
    },
    methods:{
        search()
        {
            this.loading = true
            this.noResults = true
            this.selectedSalesDoc = []
            var sf =
            {
                member_search:"",
                from_date:this.filter.date_start,
                to_date:this.filter.date_end,
                search_text:"",
                delivery_method_id:"0",
                order_status_id:"0"
            }
          
         axios.post(apiWsiSearch, sf,authHeader())
            .then (res => 
            {
                return res
            })
            .then (data =>
            {
                const resultArray = []
                const myData = data.data.data.data
                
                for (let key in myData)
                {
                    var date = myData[key].transaction_date
                    var date = new Date(date);
                    var result = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/'+  ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
                    myData[key].trans_date=result 
                    myData[key].sales_doc_num = myData[key].document_number
                    myData[key].customer_id = myData[key].member.user.old_member_id
                    myData[key].customer_name = myData[key].member.name
                    myData[key].channel = myData[key].channel.name
                    myData[key].trans_loc = myData[key].transaction_location.code
                    myData[key].shipping_method = myData[key].delivery_method
                    //myData[key].shipping_method = myData[key].sales_details.sales_data.selected.shipping.sale_delivery_method
                   // myData[key].sales_id = myData[key].sales_details.sales_data.selected.shipping.sale_delivery_method
                    //myData[key].sale_id = myData[key].sales_details.sales_data.sale_id
                    myData[key].sale_id = myData[key].document_number
                    myData[key].shipping_town = ""
                    myData[key].status = myData[key].delivery_status
                    resultArray.push(myData[key])
                    this.loading = false
                }
                this.searchResults = resultArray
                
                if(this.searchResults.length == 0)
                {
                    this.loading = false
                    this.noResults =true
                }
            })
            .catch(error => console.log(error)) 
        },
        getRowCount (items) 
        {
            return items.length
        },
        handleCancel()
        {
            this.selectedSalesDoc = []
        },
        previewPickingList()
        {
            alert ("Preview")
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/views/stockist/ssrs.vue